const mutation = {
  SET_ALL_ORDERS(state, orders) {
    state.allOrders = orders;
  },
  SET_SEARCH_PARAMS(state, data) {
    state.searchParams = data;
  },
  SET_REPORTS(state, data) {
    state.reports = data;
  },
  SET_TRIGGERED_REPORTS(state, data) {
    state.triggeredReports = data;
  },
};

export default mutation;
